import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { Col, Row } from 'react-bootstrap';
import { useDataAnnotation } from '../context/DataAnnotationProvider';
import { LoadingSpinner } from '../../../components/LoadingSpinner';

const AnnotationPatientInfo = () => {
  const { dataAnnotationPatientProfile } = useSelector(
    (state: RootState) => state.dataAnnotation,
  );
  const { loading } = useDataAnnotation();
  const patient = dataAnnotationPatientProfile['Name'];
  return (
    <Col xs={2}>
      {loading && (
        <div className="d-flex align-items-center h-100 p-3 w-100">
          <LoadingSpinner size={18} />
        </div>
      )}
      {!loading && (
        <Row className="height-50">
          <div className="d-flex align-items-center gap-1">
            <span className="heading1">{patient}</span>
          </div>
        </Row>
      )}
    </Col>
  );
};

export default AnnotationPatientInfo;
